import * as React from 'react';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import Project from 'src/entities/Project';
import DueDiligenceRequestComponent, {
  DueDiligenceRequestComponentProps
} from 'src/modules/modals/due-diligence-request/DueDiligenceRequest.component';
import {
  requestDueDiligence,
  RequestDueDiligenceAction
} from 'src/actions/project/due-diligence/RequestDueDiligence.actions';
import Person from 'src/entities/Person';
import * as requestDueDiligenceTypes from 'src/actions/project/due-diligence/Types';
import { getProject, GetProjectAction } from 'src/actions/project/get/GetProject.actions';
import { getInvestment, GetInvestmentAction } from 'src/actions/investment/get/GetInvestment.actions';

interface StateProps {
  errorMessage: {};
}

interface DispatchProps {
  requestDueDiligence(projectId: number, person: Person): Promise<RequestDueDiligenceAction>;

  getProject(projectId: number): Promise<GetProjectAction>;

  getInvestment(projectId: number, profileId: number, profileType: string): Promise<GetInvestmentAction>;
}

interface Props extends StateProps, DispatchProps {
  project: Project;
  activeProfile: Person;
  modalRef?: Modal;
}

interface State {
  isCheckedRequestDueDiligence: boolean;
  formError: {};
  success: boolean;
}

class ExpiredDataContainer extends React.Component<Props, State> {

  public state = {
    isCheckedRequestDueDiligence: false,
    formError: {},
    success: false,
  };

  public render(): React.ReactNode {
    return <DueDiligenceRequestComponent {...this.getComponentProps()}/>;
  }

  private getComponentProps(): DueDiligenceRequestComponentProps {
    return {
      project: this.props.project,
      modalRef: this.props.modalRef,
      isChecked: this.state.isCheckedRequestDueDiligence,
      handleClick: () => this.handleClick(),
      handleSubmit: () => this.handleSubmit(),
      errorMessage: this.state.formError ? this.state.formError : this.props.errorMessage,
      success: this.state.success,
    };
  }

  private handleClick() {
    this.setState({isCheckedRequestDueDiligence: !this.state.isCheckedRequestDueDiligence});
  }

  private handleSubmit() {
    if (!this.state.isCheckedRequestDueDiligence) {
      this.setState({
        formError: {
          'requestDueDiligence': 'Debes marcar la casilla para hacer la solicitud.'
        }
      });
    } else {
      this.props.requestDueDiligence(this.props.project.id, this.props.activeProfile).then((response) => {
        if (response.type === requestDueDiligenceTypes.REQUEST_DUE_DILIGENCE_SUCCESS) {
          this.props.getProject(this.props.project.id);
          this.setState({success: true});
          this.props.getInvestment(
            this.props.project.id,
            this.props.activeProfile.id,
            this.props.activeProfile.personType);
        }
      });
    }
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  requestDueDiligence: (projectId: number, person: Person): Promise<RequestDueDiligenceAction> => (
    dispatch(requestDueDiligence(projectId, person))
  ),
  getProject: (projectId: number): Promise<GetProjectAction> => (
    dispatch(getProject(projectId))
  ),
  getInvestment: (
    projectId: number,
    profileId: number,
    profileType: string
  ): Promise<GetInvestmentAction> => (
    dispatch(getInvestment(projectId, profileId, profileType))
  )

});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  errorMessage: state.requestDueDiligence.errorMessage
});

export default connect(mapStateToProps, mapDispatchToProps)(ExpiredDataContainer);



// WEBPACK FOOTER //
// ./src/modules/modals/due-diligence-request/DueDiligenceRequest.container.tsx